// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader-2Z-WC","planeSpinner":"planeSpinner-2PyOq","wrapper":"wrapper-d3Nf8"};